export default __webpack_public_path__ + "static/media/btn_close_gray.04d8286a.svg";